var card_default = {
  "cardWrapper": "uFuq9",
  "cardGap": "WE2uO",
  "cardHeaderContainer": "skltV",
  "cardContainer": "_2Jqsi",
  "fluid": "SdOxc",
  "selectionSvg": "yR5EY",
  "selectionRect": "_37vJt",
  "selectionRectActive": "meVBo",
  "last": "-zVqC",
  "cardGapAddButtonWrapper": "_4R2UI",
  "mergeHover": "_5IqnZ",
  "cardContent": "A3q4b",
  "fluidContent": "MjCHN",
  "cardBoundaryLineWrapper": "Y9JJ9",
  "visible": "IlkZf",
  "cardBoundaryLineContent": "upTYh",
  "hovered": "wVwcw",
  "cardBoundaryLine": "C-HGY",
  "cardBoundaryWarning": "_1TymM"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
